module.exports = __webpack_public_path__ + "dacia.2f96ecae1b835bcdb38d.png";